import React, { CSSProperties } from 'react'
import { Label } from '@hospitalrun/components'
import classes from '../../style.module.scss'

interface Props {
  value: string
  label: string
  name: string
  isEditable?: boolean
  placeholder?: string
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  isRequired?: boolean
  feedback?: string
  isInvalid?: boolean
  style?: CSSProperties
  disabled?: boolean
}

const TextAreaWithLabelFormGroup = (props: Props) => {
  const {
    value,
    label,
    name,
    isEditable,
    isRequired,
    onChange,
    style,
    placeholder,
    disabled,
  } = props
  const id = `${name}TextField`
  return (
    <div>
      <Label
        className={classes.label}
        text={label}
        htmlFor={id}
        isRequired={isRequired && isEditable}
      />
      <div className="form-group">
        {isEditable ? (
          <textarea
            style={style}
            rows={4}
            value={value}
            disabled={!isEditable || disabled}
            onChange={onChange}
            placeholder={placeholder}
            className={'form-control textareaPlaceholder'}
          />
        ) : (
          <div>
            <pre className="text-secondary">{value}</pre>
            <br />
            <br />
          </div>
        )}
      </div>
    </div>
  )
}

TextAreaWithLabelFormGroup.defaultProps = {
  value: '',
}

export default TextAreaWithLabelFormGroup
